import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { showProfile } from "../../api";
import { formatDate, getOrigin } from "../../helpers"; // tambahkan getOrigin
import { titleState } from "../../storages";
import { tokenState, userState } from "../../storages/auth";
import LoginAs from "../../components/layouts/LoginAs";
import Table, { Tbody, Td, Tr } from "../../components/Table";
import Loading from "../../components/Loading";

const Profile = () => {
  const setTitle = useSetRecoilState(titleState);
  const token = useRecoilValue(tokenState);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTitle("Kalender Akademik");
  }, [setTitle]);

  const user = useRecoilValue(userState);

  const [mhs, setMhs] = useState({});

  useEffect(() => {
    const showDataMhs = async () => {
      try {
        const res = await showProfile(user.id, token);
        if (res.data) {
          setMhs(res.data.mhs);
          setIsLoaded(true);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (token && user.id) {
      showDataMhs();
    }
  }, [token, user.id]);

  // const [collapseDisc, setCollapseDisc] = useState(false);

  // const toggleCollapseDisc = () => {
  //   setCollapseDisc(!collapseDisc);
  // };

  return (
    <>
      <div className="bg-white shadow rounded-3 mx-2 px-1">
        {/* <LoginAs /> */}
        <div className="row">
          <div className="col-lg-12 mt-2 px-2">
            <div className="bg-gradient-primary rounded-3 p-0">
              {/* MAIN EVENT */}
              <div className="score-background rounded-top-3 shadow-nice p-4">
                <div>
                  <div>
                    <p className="my-0 text-center text-white text-shadow fw-semibold fst-italic fs-5">
                      TO BE THE{" "}
                      <span className="text-warning fs-5">FIRST CHOICE</span> OF
                      INDUSTRY
                    </p>
                  </div>
                </div>
              </div>
              {/* END MAIN EVENT */}

              <div className="text-center mt-4 mb-4">
                {isLoaded ? (
                  <>
                    <img
                      src={`${getOrigin()}/storage/kalender_akademik/${user.cabang}/kalender2026.webp`}
                      alt="Kalender Akademik"
                      className="rounded-4 shadow-lg"
                      style={{ maxWidth: "100%", width: "100%" }}
                    />
                  </>
                ) : (
                  <Loading />
                )}
              </div>

              <div className="bg-gradient-primary rounded-3 p-0 pb-5"></div>

            </div>
          </div>
        </div>
      </div>

      {/* <Modal
          show={showB}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          size='lg'
          contentClassName='bg-gradient-primary-3'
      >
          <Modal.Header 
              className='d-flex justify-content-center border-secondary'
          >
              <Modal.Title>
                  <div className="navbar-brand text-white d-flex align-items-center p-0">
                      <img src="/img/logo/AP-W.png" alt="" width={48}/>
                      <span className="fs-5">ALFA PRIMA</span>
                  </div>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body className='text-gray-500'>
              <h5 className="text-center text-white">Pengumuman 2</h5>

              <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Atque nihil, repellendus modi quasi in at minus est inventore quisquam ipsa quidem vitae optio error voluptates.</p>

              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Cupiditate, neque? Quos tenetur, expedita labore provident placeat perspiciatis magni aut odit quasi omnis illo incidunt sunt deleniti soluta distinctio laudantium minus nobis qui iure quia recusandae porro sit? Doloremque harum sunt soluta magni sit tenetur aut recusandae, beatae repellat eveniet porro.</p>

              <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem, fuga!</p>
          </Modal.Body>
          <Modal.Footer className='text-white border-secondary'>
          <Button 
              size='sm'
              onClick={handleCloseB}
              className='btn-primary-2'
          >
              Oke, mengerti
          </Button>
          </Modal.Footer>
      </Modal> */}
    </>
  );
};

export default Profile;
